import React from 'react';
import { Brain, Moon, Dumbbell, Apple, Heart, Users } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { featureCards } from '../data/mock';

const iconMap = {
  Brain: Brain,
  Moon: Moon,
  Dumbbell: Dumbbell,
  Apple: Apple,
  Heart: Heart,
  Users: Users
};

const FeatureCards = () => {
  const { language } = useLanguage();

  return (
    <section id="features" className="py-24 bg-gradient-to-b from-[#0d1f1f] to-[#1a3334]">
      <div className="max-w-[1400px] mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16 space-y-4">
          <h2 className="text-5xl md:text-6xl font-bold text-white">
            {language === 'en' ? 'Build Your' : 'Construye Tu'}{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-teal-400">
              {language === 'en' ? 'Complete Wall' : 'Muro Completo'}
            </span>
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            {language === 'en'
              ? 'Everything you need to become your best version'
              : 'Todo lo que necesitas para ser tu mejor versión'}
          </p>
        </div>

        {/* Feature Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {featureCards.map((feature, index) => {
            const Icon = iconMap[feature.icon];
            return (
              <div
                key={feature.id}
                className="group relative overflow-hidden rounded-3xl bg-cover bg-center h-[400px] cursor-pointer transition-all duration-500 hover:scale-[1.02] hover:shadow-2xl hover:shadow-emerald-500/20"
                style={{
                  backgroundImage: `linear-gradient(to bottom, rgba(13, 31, 31, 0.7), rgba(26, 51, 52, 0.95)), url(${feature.image})`
                }}
              >
                {/* Content */}
                <div className="absolute inset-0 p-8 flex flex-col justify-between">
                  {/* Icon */}
                  <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-emerald-500/20 border border-emerald-500/30 backdrop-blur-sm group-hover:bg-emerald-500 group-hover:scale-110 transition-all duration-300">
                    <Icon className="w-8 h-8 text-emerald-400 group-hover:text-white transition-colors" />
                  </div>

                  {/* Text */}
                  <div className="space-y-3">
                    <h3 className="text-2xl font-bold text-white group-hover:text-emerald-400 transition-colors">
                      {language === 'en' ? feature.title_en : feature.title_es}
                    </h3>
                    <p className="text-gray-300 group-hover:text-white transition-colors">
                      {language === 'en' ? feature.description_en : feature.description_es}
                    </p>
                  </div>
                </div>

                {/* Hover Effect Border */}
                <div className="absolute inset-0 border-2 border-transparent group-hover:border-emerald-500/50 rounded-3xl transition-all duration-300"></div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FeatureCards;